<template>
  <div>
    <h3>This is the Pricing page.</h3>
  </div>
</template>

<script>
export default {
  name: 'pricing',
};
</script>
